import ReactOnRails from 'react-on-rails';

import SchoolInfoForm from 'bundles/lp/shukatsufes2026_spring/SchoolInfoForm';

ReactOnRails.register({ SchoolInfoForm });
